
import { Layout } from "@/components/Layout/Layout";
import { MaintenanceNote } from "@/components/Groups/MaintenanceNote";

const Groups = () => {
  return (
    <Layout>
      <div className="container max-w-7xl mx-auto px-4 py-8">
        {/* Maintenance Note - only visible on /groups */}
        <MaintenanceNote />
      </div>
    </Layout>
  );
};

export default Groups;
